import { Box } from "@mui/material"
import "./styles.scss"

export function GraphContainer({ loading, children }: { loading?: boolean, children?: any }) {
    return <Box className={`graphMainContainer ${loading ? "loading" : ""}`}>
        {children}
    </Box>
}